// Deferred represents a Promise and its associated resolve and reject
// functions.
//
// Deferreds should always be private, since they allow changing the contained
// Promise. Callers interested in the values should be given access to the
// Promise only.
var Deferred = /** @class */ (function () {
    function Deferred() {
        var resolve = undefined;
        var reject = undefined;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        if (!resolve) {
            throw new Error("resolve wasn't set!");
        }
        if (!reject) {
            throw new Error("reject wasn't set!");
        }
        this.promise = promise;
        this.resolve = resolve;
        this.reject = reject;
    }
    return Deferred;
}());
export { Deferred };
//# sourceMappingURL=deferred.js.map